import { MouseEvent } from 'react';
import { NavLink as NavLinkRouter, NavLinkProps } from 'react-router-dom';
import { useDependencies } from '../dependencies';

const NavLink = (props: NavLinkProps): JSX.Element => {
  const { children, onClick, ...rest } = props;

  const {
    services: { tracker },
  } = useDependencies();

  const handleClick = async (e: MouseEvent<HTMLAnchorElement>): Promise<void> => {
    const element = e.target as HTMLElement;

    const trackingProps = {
      elementText: element.innerText,
      elementId: element.id,
    };

    await tracker.track('clicked-button', trackingProps);

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <NavLinkRouter {...rest} onClick={handleClick}>
      {children}
    </NavLinkRouter>
  );
};

export { NavLink };
